/* import __COLOCATED_TEMPLATE__ from './banner-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();